module.exports = __webpack_public_path__ + "static/media/finalizing-sm.e8717736.gif";